import { useT } from "@transifex/react";
import { useState } from "react";

export function useContactValidation() {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const t = useT();

  const validatePhone = (phone: string): boolean => {
    const phoneRegex = /^\+?[1-9]\d{0,2}[\s-]?\(?\d{1,4}\)?[\s-]?\d{3,4}[\s-]?\d{3,4}[\s-]?\d{0,4}$/;
    return phoneRegex.test(phone);
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  const validateContact = (args: { contact?: string; isPhoneForm: boolean }) => {
    const { contact, isPhoneForm } = args;
    if (!contact) {
      setError(true);
      setErrorMessage(t("Contact information is required."));
      return false;
    }

    if (isPhoneForm && !validatePhone(contact)) {
      setError(true);
      setErrorMessage("Please enter a valid phone number.");
      return false;
    }

    if (!isPhoneForm && !validateEmail(contact)) {
      setError(true);
      setErrorMessage("Please enter a valid email address.");
      return false;
    }

    setError(false);
    setErrorMessage("");
    return true;
  };

  const clearError = () => {
    setError(false);
    setErrorMessage("");
  };

  return {
    error,
    errorMessage,
    validateContact,
    clearError,
  };
}
